import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase/app';

interface PushResult {
  sent: number;
  failed?: number;
  total?: number;
  nickname?: string;
}

export async function sendPushToAll(
  title: string,
  body: string,
  urgent = false,
): Promise<{ success: boolean; message?: string; sent?: number }> {
  try {
    const fn = httpsCallable<{ title: string; body: string; urgent: boolean }, PushResult>(
      functions, 'sendAdminPush',
    );
    const result = await fn({ title, body, urgent });
    return { success: true, sent: result.data.sent, message: `${result.data.sent}명에게 전송 완료` };
  } catch (err: any) {
    return { success: false, message: err.message ?? String(err) };
  }
}

export async function sendPushToUser(
  nickname: string,
  title: string,
  body: string,
  urgent = false,
): Promise<{ success: boolean; message?: string }> {
  try {
    const fn = httpsCallable<{ title: string; body: string; nickname: string; urgent: boolean }, PushResult>(
      functions, 'sendAdminPushToUser',
    );
    const result = await fn({ title, body, nickname, urgent });
    return { success: true, message: `${nickname}에게 전송 완료 (${result.data.sent}건)` };
  } catch (err: any) {
    return { success: false, message: err.message ?? String(err) };
  }
}
